// import React from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";

// const BarGraph = ({
//   data,
//   bars,
//   xKey,
//   title,
//   onBarClick,
//   chartHeight = 500, // Fixed height
//   containerWidth = 1200, // Fixed container width
// }) => {
//   // Calculate the width of the chart based on the number of bars (adjust as needed)
//   const chartInnerWidth = data.length * 100; // Each bar width is 100px

//   return (
//     <div style={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
//       <h2>{title}</h2>
//       <div
//         style={{
//           width: `${containerWidth}px`, // Fixed container width
//           overflowX: "auto", // Enable horizontal scrolling
//           margin: "0 auto",
//           border: "1px solid #ccc",
//           borderRadius: "8px",
//         }}
//       >
//         <div style={{ width: `${chartInnerWidth}px`, height: chartHeight }}>
//           <BarChart
//             width={chartInnerWidth} // Set chart width to the dynamic width
//             height={chartHeight}
//             minWidth={chartInnerWidth}
//             data={data}
//             margin={{
//               top: 20,
//               right: 30,
//               left: 20,
//               bottom: 5,
//             }}
//           >
//             <CartesianGrid strokeDasharray="3 3" />
//             <XAxis dataKey={xKey} />
//             <YAxis />
//             <Tooltip />
//             <Legend />
//             {bars.map((bar, index) => (
//               <Bar
//                 key={index}
//                 dataKey={bar.key}
//                 fill={bar.color}
//                 name={bar.name}
//                 barSize={30}
//                 onClick={onBarClick ? (data) => onBarClick(data) : undefined}
//               />
//             ))}
//           </BarChart>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BarGraph;

import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const BarGraph = ({
  data,
  bars,
  xKey,
  title,
  onBarClick,
  chartHeight = 500, // Fixed height
  containerWidth = 1200, // Fixed container width
  minWidth = 800, // Minimum width of the chart
}) => {
  // Calculate the width of the chart based on the number of bars (adjust as needed)
  const chartInnerWidth = Math.max(data.length * 100, minWidth); // Ensure the width is at least 'minWidth'

  return (
    <div style={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
      <h2>{title}</h2>
      <div
        style={{
          width: "100%", // Fixed container width
          overflowX: "auto",
          overflowY: "hidden",
          // Enable horizontal scrolling
          margin: "0 auto",
          // border: "1px solid #ccc",
          borderRadius: "8px",
          // display: "flex",
          // alignItems: "center",
          // justifyContent: "center",
        }}
      >
        <div
          style={{
            width: `${chartInnerWidth}px`,
            height: chartHeight,
          }}
        >
          <BarChart
            width={chartInnerWidth} // Set chart width to the dynamic width (minWidth constrained)
            height={chartHeight}
            // style={{ background: "red" }}
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xKey} />
            <YAxis />
            <Tooltip />
            <Legend />
            {bars.map((bar, index) => (
              <Bar
                key={index}
                dataKey={bar.key}
                fill={bar.color}
                name={bar.name}
                barSize={30}
                onClick={onBarClick ? (data) => onBarClick(data) : undefined}
              />
            ))}
          </BarChart>
        </div>
      </div>
    </div>
  );
};

export default BarGraph;
